import {
  ErrorHandler,
  NgModule,
  LOCALE_ID,
  inject,
  provideAppInitializer,
  isDevMode,
} from '@angular/core';
import localeEs from '@angular/common/locales/es';
import { registerLocaleData } from '@angular/common';

import { AppComponent } from './app.component';

import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';

import { AutorizacionModule } from './compartido/autorizacion/autorizacion.module';
import { DialogosModule } from './compartido/dialogos/dialogos.module';
import { InteriorModule } from './interior/interior.module';

import { MatDatepickerModule } from '@angular/material/datepicker';

import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { InterceptorAPI } from './compartido/autenticacion/api.interceptor';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { FORMATO_FECHA_MAT } from './compartido/utilidades/compartido.static';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { TraceService, createErrorHandler } from '@sentry/angular';
import { Router } from '@angular/router';
import { ServiceWorkerModule } from '@angular/service-worker';

registerLocaleData(localeEs, 'es');

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,

    AutorizacionModule,
    DialogosModule,
    InteriorModule,

    MatDatepickerModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: !isDevMode(),
      // Register the ServiceWorker as soon as the application is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000',
    }),
  ],
  providers: [
    // Http Client e interceptores
    provideHttpClient(withInterceptorsFromDi()),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: InterceptorAPI,
      multi: true,
    },

    // Localización
    { provide: LOCALE_ID, useValue: 'es-CO' },

    // Material
    { provide: MAT_DATE_LOCALE, useValue: 'es-CO' },
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE],
    },
    { provide: MAT_DATE_FORMATS, useValue: FORMATO_FECHA_MAT },
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: { subscriptSizing: 'dynamic' },
    },

    // Sentry
    {
      provide: ErrorHandler,
      useValue: createErrorHandler(),
    },
    {
      provide: TraceService,
      deps: [Router],
    },
    provideAppInitializer(() => {
      inject(TraceService);
    }),
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
